import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var TodoHelper = function TodoHelper() {
  _classCallCheck(this, TodoHelper);

  _defineProperty(this, "TODO_TYPES", {
    _2013: 0
  });
};

export default new TodoHelper();